<template>
  <div class="ticket-detail-page">
    <div class="content-box">
      <div class="box1">
        <img alt="" class="goods-img" src="images/test/03.jpeg">
        <div class="goods-detail">
          <div>
            <div>
              <div>{{ goodsMsg.name }}</div>
              <div></div>
            </div>
            <div class="mt8 flex-row col-center" style="font-size: 11px;color: #808080;">
              <van-rate v-model="goodsMsg.score"
                        allow-half
                        color="#ffd21e"
                        readonly
                        size="12"
                        void-icon="star"
              />
              <span>{{ goodsMsg.score }}分</span>
              <span style="margin-left: 20px">{{ goodsMsg.appraise_num }}评价></span>
            </div>
            <div class="mt8">
              <div class="flex-row col-center" style="font-size: 11px;color: #808080">
                <span style="margin-right: 4px">营业至18:30</span>|
                <span style="margin: 0 4px">{{ goodsMsg.stop_car ? '可停车' : '' }}</span>|
                <span style="margin-left: 4px">{{ goodsMsg.has_wifi ? 'wifi' : '' }}</span>
              </div>
            </div>
            <div class="mt8 flex-row row-between col-center budo-30">
              <div style="font-size: 14px;color: #333333;">{{ goodsMsg.address }}</div>
              <div class="iconfont icon-daohang" style="color: #808080;font-size: 20px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="box2">
        <div class="flex-row col-center">
          <div class="line1"></div>
          <div class="ml4" style="font-size: 15px;font-weight: bold;color: #252525;">门票</div>
        </div>
        <div>
          <div v-for="item of ticketList" :key="item.id" class="ticket-item-box mt14 flex-row">
            <img alt="" src="images/test/03.jpeg">
            <div class="ml8 flex-col row-between">
              <div style="font-size: 14px">{{ item.name }}</div>
              <div class="flex-row row-between col-center" style="width: 280px">
                <div class="flex-row col-center" style="font-size: 10px">
                  <span style="margin-right: 4px;color: #808080">成人票</span>|
                  <span style="margin-left: 4px;color: #0356C4">预定须知</span>
                </div>
                <div class="flex-row col-center" style="font-size: 14px">
                  <div style="color: #FC3F3F">{{ item.price }}</div>
                  <div class="ml8 pay-btn">预定</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box3">
        <div class="flex-row col-center">
          <div class="line1"></div>
          <div class="ml4" style="font-size: 15px;font-weight: bold;color: #252525;">交通信息</div>
        </div>
        <div class="mt8" style="font-size: 12px">
          暂无交通信息
        </div>
      </div>
      <div class="box4">
        <div class="flex-row col-center">
          <div class="line1"></div>
          <div class="ml4" style="font-size: 15px;font-weight: bold;color: #252525;">景点介绍</div>
        </div>
        <div class="mt8" style="font-size: 12px">
          暂无介绍
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      goodsMsg: {
        id: 1,
        name: '麓湖水城',
        score: 4.8,
        address: '成都市天府新区天府大道',
        open_time: '4/10-7/31 10:00-22:00',
        price1: 200,
        price2: 148,
        appraise_num: 22154,
        like: '94%',
        stop_car: 1,
        has_wifi: 1
      },
      ticketList: [
        {
          id: 1,
          name: '麓客岛码头乘坐小船门票麓客岛码头',
          price: 148
        },
        {
          id: 2,
          name: '麓客岛码头乘坐小船门票麓客岛码头',
          price: 148
        },
        {
          id: 3,
          name: '麓客岛码头乘坐小船门票麓客岛码头',
          price: 148
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
